/**
* this displays the documents page
*
* Created by Paul on 6/6/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

// action import
import { ActionCreator } from '../../actions/'

// Configurations
import constants from '../../constants'
import config from '../../config'

import NumberFormat from 'react-number-format'

// material-ui import
import { withStyles, makeStyles } from '@material-ui/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Done from '@material-ui/icons/Done'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import ListItemText from '@material-ui/core/ListItemText'
import Select from '@material-ui/core/Select'
import Checkbox from '@material-ui/core/Checkbox'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import TextField from '@material-ui/core/TextField'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import FileIcon from '@material-ui/icons/FileCopy'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import CircularProgress from '@material-ui/core/CircularProgress'

// components import
import DocumentsTable from '../../components/DocumentsTable/'
import FileBrowser from '../../components/FileBrowser/'

import withMobileDialog from '@material-ui/core/withMobileDialog';

import Cookies from 'js-cookie'
import compose from 'recompose/compose'

import Expand from 'react-expand-animated'

// style import
import './style.scss'

const styles = theme => ({
    gridroot: {
        flexGrow: 1,
    },
    root: {
        padding: 20,
    },
    formControl: {
        width: '100%',
    },
    card: {
        height: '100%',
        padding: 20,
    },
    title: {
        fontSize: 16,
    },
    pos: {
        marginBottom: 12,
    },
    card_body: {
        fontSize: 13,
    },
    list_root: {
        width: '100%',
    },
    checkbox: {
        padding: 2,
    },
    list_item: {
        
        minWidth: 32,
    },
    textField: {
        marginTop: 0,
        width: 'calc(100% - 175px)',
        marginRight: 20,
    },
    button: {
        marginTop: 13,
        width: 155,
    },
    uploadButton: {
        marginTop: 25,
        width: 150,
    },
    uploadGrid: {
        textAlign: 'right',
    },
    rightIcon: {
        marginLeft: 10,
    },
    dialog: {
        minWidth: 400,
    },
    progress: {
        position: 'absolute',
        right: 5,
    },
    uploadIndicator: {
        float: 'left',
    },
})


class Documents extends Component {

    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleYearChange = this.handleYearChange.bind(this)
        this.handleFundSelectChange = this.handleFundSelectChange.bind(this)
        this.handleFundChange = this.handleFundChange.bind(this)
        this.validateUpload = this.validateUpload.bind(this);
        this.upload = this.upload.bind(this);
        this.state = {
            funds: [],
            fund: '',
            checked: [],
            viewDocuments: false,
            category: '',
            year: '',
            file: { name: '', location: null },
            isModalOpen: false,
            modal: { title: '', body: '', warning: '', valid: false },
            upload: {
                success: false,
                response: '',
            }
        }
    }

    componentDidMount() {
        const { getFundsListData, getDocumentsCategories } = this.props
        getFundsListData()
        getDocumentsCategories()
    }

    handleFundSelectChange(event) {
        
        const { getDocumentsData, fundsListData, clearDocumentsData } = this.props

        let funds = event.target.value
        
        this.setState({
            funds: funds
        })

        clearDocumentsData()

        if (funds.length === 1) {
            getDocumentsData(funds[0].member_id)

            this.setState({
                viewDocuments: true
            })
        }
        else {
            this.setState({
                viewDocuments: false
            })
        }
    }

    
    handleFundChange(event) {
        const { getDocumentsData, clearDocumentsData, getDocusignData } = this.props
        
        let fund = event.target.value

        this.setState({
            fund: fund
        })

        clearDocumentsData()
        
        getDocumentsData(fund.member_id)
        getDocusignData(fund.member_id)

        this.setState({
            viewDocuments: true
        })
    }

    handleChange(event) {
        this.setState({
            category: event.target.value
        })
    }

    handleYearChange(event) {
        this.setState({
            year: event.target.value
        })
    }

    openFileChange(dialog) {
        const name = dialog.target.value.split(/\\|\//).pop()

        this.setState({
            file: {
                name: name,
                location: dialog.target.files[0]
            } 
        })
    }

    showDocuments() {

        const { getDocumentsData } = this.props

        getDocumentsData(this.state.fund.member_id)

        this.setState({
            viewDocuments: true
        })
    }

    validateUpload() {
        
        this.setState({
            upload: {
                response: ''
            }
        })

        if (this.state.file.size <= 0) {
            this.setState({
                modal: {
                    title: 'File Is Too Small',
                    body: 'This file contains no data',
                    warning: '',
                    valid: false
                }
            })
        }
        else if (this.state.file.size > 10485760) {
            this.setState({
                modal: {
                    title: 'File Is Too Large',
                    body: 'The file must be no larger than 10MB',
                    warning: '',
                    valid: false
                }
            })   
        }
        else if (this.state.file.name.length > 100) {
            this.setState({
                modal: {
                    title: 'Invalid File Name',
                    body: 'The file name must be less than 100 characters',
                    warning: '',
                    valid: false
                }
            })   
        }
        else {

            let warning = ''

            if (this.state.funds.length > 1 ) {
                warning = <Typography variant="body1" component="p" color="secondary">Warning - this will upload the document to <span className="highlight">{ this.state.funds.length }</span> funds</Typography>
            }


            this.setState({
                modal: {
                    title: 'Confirm File Upload',
                    body: <Typography variant="body1" component="p">Uploading <span className="highlight">{ this.state.file.name }</span> to <span className="highlight">{ this.state.category.label }</span> in <span className="highlight">{ this.state.year.label }</span></Typography>,
                    warning: warning,
                    valid: true
                }
            })
        }

        this.setState({
            isModalOpen: true
        })
    }

    upload() {

        const { fundsListData } = this.props

        // Grab CSRFToken from cookie
        const csrftoken = Cookies.get('csrftoken')

        // Flag as uploading
        this.setState({
            isUploading: true
        })

        let fileName = this.state.file.name
        let type = this.state.file.location.type
        let year = this.state.year.label


        if (year.startsWith('General')) {
            year = ''
        }
        else {
            year = year.split('-')[1]
        }
        
        const fileData = {
            file: fileName,
            file_size: this.state.file.size,
            category: this.state.category.value,
            year: year,
            funds: this.state.fund,
            type: type,
        }

        let formData = new FormData()
        formData.append('upload_data', JSON.stringify(fileData))
        formData.append(fileName, this.state.file.location)
        
        let requestURL = config.endpoints.adviserDocumentUpload

        fetch(requestURL, {
            method: 'POST',
            credentials: "include",
            headers: {
                'X-CSRFToken': csrftoken,
                'X-Requested-With': 'XMLHttpRequest',
            },
            mode: 'cors',
            cache: 'default',
            body: formData,
        }).then(res => res.json()).then((data) => {
            
            if (data === 'Success') {
                
                this.setState({
                    upload: {
                        success: true,
                        response: 'Document uploaded successfully'
                    }
                })

                this.showDocuments()
            }
            else {

                this.setState({
                    upload: {
                        success: false,
                        response: data
                    }
                })
            }

            // Enable controls
            this.setState({
                isUploading: false,
                file: { name: '', location: null },
            })

        }).catch(err => console.log(err))
    

        this.setState({
            isModalOpen: false
        })
    }

    handleCloseModal() {
        this.setState({
            isModalOpen: false
        })
    }

    render() {
        
        const { classes, isLoading, fundsListData, documentListData, deleteDocument, documentsLoading, documentCategories, fullScreen, selectableTaxYears, docusignDocuments } = this.props
        
        const ITEM_HEIGHT = 48
        const ITEM_PADDING_TOP = 8
        const MenuProps = {
            PaperProps: {
                style: {
                    maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
                    minWidth: 'none',
                },
            },
        }

        let disabled = (this.state.fund === '' || !this.state.category || !this.state.file.name || this.state.isUploading || this.state.year === '')

        return (
            
                <div className="funds main-wrapper">
                    
                    <Card raised className={classes.card}>
                        <CardContent>

                            <Typography className={classes.title} variant="h5" component="h2">
                                Document Upload
                            </Typography>

                            <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                                Select one or more funds, a category, a year and a file to upload
                            </Typography>

                            <div className={classes.gridroot}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel htmlFor="age-simple">Select Fund</InputLabel>
                                            <Select
                                                value={this.state.fund}
                                                onChange={this.handleFundChange}
                                                input={<Input id="age-simple" />}
                                                renderValue={value => `${value.fund_name}`}
                                                disabled={ this.state.isUploading }
                                            >
                                                { fundsListData.map((fund, index) => (
                                                    <MenuItem key={index} value={fund}>
                                                        {fund.fund_name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        {/*
                                        <FormControl className={classes.formControl}>
                                            <InputLabel htmlFor="select-multiple-checkbox">Select Fund</InputLabel>
                                            <Select
                                                multiple
                                                value={ this.state.funds }
                                                onChange={ this.handleFundSelectChange }
                                                input={<Input id="select-multiple-checkbox" />}
                                                renderValue={ ((selected, index) =>
                                                        selected
                                                            .map(selectedFund => <span key={ index }>{ selectedFund.fund_name }</span>)
                                                            .reduce((prev, curr) => [prev, ', ', curr])
                                                        )}
                                                MenuProps={ MenuProps }
                                                disabled={ this.state.isUploading }
                                            >
                                            { fundsListData.map((fund, index) => (
                                                <MenuItem key={ index } value={ fund }>
                                                    <Checkbox color="primary" checked={ this.state.funds.indexOf(fund) > -1 } />
                                                    <ListItemText primary={ fund.fund_name } />
                                                </MenuItem>
                                            ))}
                                            </Select>
                                        </FormControl>
                                        */}
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel htmlFor="category">Select Category</InputLabel>
                                            <Select
                                                value={ this.state.category }
                                                onChange={ this.handleChange }
                                                input={<Input name="category" id="category" />}
                                                autoWidth
                                                disabled={ this.state.isUploading }
                                            >

                                                { documentCategories.map((category, index) => {
                                                    return (
                                                        <MenuItem key={ index } value={ category }>{ category.label }</MenuItem>
                                                    )
                                                })}
                                                
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </div>

                            <div className={classes.gridroot}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.formControl}>
                                            <InputLabel htmlFor="year">Select Financial Year</InputLabel>
                                            <Select
                                                value={ this.state.year }
                                                onChange={ this.handleYearChange }
                                                input={<Input name="year" id="year" />}
                                                autoWidth
                                                disabled={ this.state.isUploading }
                                            >

                                                { selectableTaxYears.map((year, index) => {
                                                    return (
                                                        <MenuItem key={ index } value={ year }>{ year.label }</MenuItem>
                                                    )
                                                })}
                                                
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>

                                        <TextField
                                            id="standard-with-placeholder"
                                            label="Document"
                                            className={classes.textField}
                                            value={ this.state.file.name }
                                            disabled
                                        />

                                        <input
                                            className={classes.fileButton}
                                            style={{ display: 'none' }}
                                            id="raised-button-file"
                                            multiple
                                            type="file"
                                            onChange={ this.openFileChange.bind(this) }
                                            disabled={ this.state.isUploading }
                                        />
                                        <label htmlFor="raised-button-file">
                                            <Button variant="outlined" component="span" className={classes.button}>
                                                Select Document
                                            </Button>
                                        </label>

                                    </Grid>

                                </Grid>
                            </div>
                            
                            <div>
                                <Button variant="outlined" color="default" disabled={ disabled } className={ classes.uploadButton } onClick={ this.validateUpload }>
                                    
                                    { this.state.isUploading ? 'Uploading' : 'Upload' }

                                </Button>

                                <span className="upload-response"><span className={ this.state.upload.success ? 'upload-response--success' : 'upload-response--errors' }>{ this.state.upload.response }</span></span>
                            </div>

                        </CardContent>

                        <Expand open={ this.state.viewDocuments && documentListData.length > 0 }>

                            <div className="documents-list-container">    
                                <FileBrowser document_tree={ documentListData } envelope={docusignDocuments} member_id={this.state.fund.member_id} />
                            </div>

                        </Expand>

                        {/*<CardActions>
                            <Button disabled={ this.state.funds.length != 1 || this.state.viewDocuments } size="small" onClick={() => this.showDocuments()}>{ this.state.funds.length === 1 ? 'View Fund Documents' : 'Select a Single Fund to View Documents' }</Button>
                        </CardActions>*/}
                    </Card>

                    <Dialog
                        fullScreen={ fullScreen }
                        open={ this.state.isModalOpen }
                        onClose={ () => this.handleCloseModal() }
                        aria-labelledby="responsive-dialog-title"
                    >
                        <DialogTitle id="responsive-dialog-title">{ this.state.modal.title }</DialogTitle>
                        <DialogContent>
                            <DialogContentText className={ classes.dialog }>

                                { this.state.modal.body }

                                { this.state.modal.warning }

                            </DialogContentText>
                        </DialogContent>
                        { this.state.modal.valid &&
                            <DialogActions>
                                <Button onClick={ () => this.handleCloseModal() } color="primary">
                                    Cancel
                                </Button>
                                <Button onClick={ () => this.upload() } color="primary" autoFocus>
                                    Confirm
                                </Button>
                            </DialogActions>
                        }
                        { !this.state.modal.valid &&
                            <DialogActions>
                                <Button onClick={ () => this.upload() } color="primary" autoFocus>
                                    Close
                                </Button>
                            </DialogActions>
                        }
                    </Dialog>

                </div>
        )
    }
}

// define the prop types
Documents.propTypes = {
    classes: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    fundsListData: PropTypes.array,
    documentsLoading: PropTypes.bool,
    documentListData: PropTypes.array,
    documentCategories: PropTypes.array,
    fullScreen: PropTypes.bool.isRequired,
    selectableTaxYears: PropTypes.array,
    docusignDocuments: PropTypes.array
}

const mapStateToPros = (state) => {
    return {
        isLoading: state.fundsSummaryState.isLoading,
        fundsListData: state.fundsSummaryState.fundsListData,
        documentsLoading: state.documentsState.documentsLoading,
        documentListData: state.documentsState.documentListData,
        documentCategories: state.documentsState.documentCategories,
        selectableTaxYears: state.documentsState.selectableTaxYears,
        docusignDocuments: state.documentsState.docusignDocuments,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getFundsListData: action.getFundsListData,
        deleteDocument: action.deleteDocument,
        getDocumentsData: action.getDocumentsData,
        getDocumentsCategories: action.getDocumentsCategories,
        clearDocumentsData: action.clearDocumentsData,
        getDocusignData: action.getDocusignData,
    }
}

export default compose(
    connect(mapStateToPros,mapDispatchToProps),
    withStyles(styles),
    withMobileDialog()
)(Documents)


// WEBPACK FOOTER //
// ./src/pages/Documents/index.js